import { render, staticRenderFns } from "./ClienteModal.vue?vue&type=template&id=481a64d2&scoped=true"
import script from "./ClienteModal.vue?vue&type=script&lang=js"
export * from "./ClienteModal.vue?vue&type=script&lang=js"
import style0 from "./ClienteModal.vue?vue&type=style&index=0&id=481a64d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a64d2",
  null
  
)

export default component.exports